<template>
  <SoAlert class="mb-4">
    <SoSkeleton
      v-if="current.latestRead.isFetching"
      :type="['text', 'list-item-two-line', 'button', 'button']"
    />
    <template v-else-if="cantSubmitRightNow">
      <p>If a reading can’t be submitted right now:</p>
      <ul class="ml-4">
        <li>Proceed with suggested amount and change payment schedule or</li>
        <li>Change amount with the estimation calculator</li>
      </ul>
    </template>
    <template v-else>
      <template v-if="lastRead">
        <h5>We haven’t had a reading in a while.</h5>
        <p>
          The suggested payment amount is based on usage estimation. We last
          received a read on {{ formatDate(lastRead) }}. Submit a new read for
          an updated payment amount.
        </p>
      </template>
      <template v-else>
        <h5>We haven’t had a reading.</h5>
        <p>
          The suggested payment amount is based on usage estimation. Submit a
          new read for an updated payment amount.
        </p>
      </template>
      <SoButton
        title="Fetch Reading"
        type="table-action"
        class="mr-2 mt-2"
        @click="fetchReadings()"
      />
      <SoButton
        title="Can’t Submit Read Now"
        type="table-action"
        @click="cantSubmitRightNow = true"
      />
    </template>
  </SoAlert>
  <SubmitReadingsModal v-model="isSubmitReadingsModalOpen" />
  <SoDialog
    v-model="isFetchSmartReadsModalOpen"
    card-title="Fetch Smart Readings"
  >
    <FetchSmartReadWidgets />
    <SoButton
      title="Submit Manual Reading"
      class="mt-8"
      @click="isSubmitReadingsModalOpen = true"
    />
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { formatDate } from "@/helpers/dateHelper"
  import FetchSmartReadWidgets from "@/components/meterpoints/FetchSmartReadWidgets.vue"
  import SubmitReadingsModal from "@/views/customer/meterpoints/modals/SubmitReadingsModal.vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"

  export default defineComponent({
    components: {
      FetchSmartReadWidgets,
      SubmitReadingsModal,
      SoDialog,
      SoAlert,
      SoButton,
      SoSkeleton,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        cantSubmitRightNow: false,
        isFetchSmartReadsModalOpen: false,
        isSubmitReadingsModalOpen: false,
        formatDate,
      }
    },
    computed: {
      smartMeters() {
        return this.current.meterpoints.data.filter(
          (meterpoint) => meterpoint.hasSmartMeter,
        )
      },
      lastRead() {
        return this.current.latestRead.data?.date
      },
    },
    methods: {
      fetchReadings() {
        if (this.smartMeters.length) {
          this.isFetchSmartReadsModalOpen = true
        } else {
          this.isSubmitReadingsModalOpen = true
        }
      },
    },
  })
</script>
